import { t } from '@/lib/i18n';
import { useState } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageContainer } from '@ant-design/pro-components';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { AsyncBoundary } from '@/components/async-boundary';
import {
  canAccess,
  requirePermission,
  useAccess,
} from '@/features/auth/access';
import { useDictTypes } from '@/features/dict/dict-api';
import { DictTypeFormModal } from '@/features/dict/type/form-modal';
import { DictTypeTable } from '@/features/dict/type/table';
import { useDocumentTitle } from '@/hooks/use-document-title';

export const Route = createFileRoute('/_authenticated/system/dicts/')({
  beforeLoad: async ({ context, location }) => {
    await requirePermission(context.queryClient, location.href, 'dicts:read');
  },
  component: DictTypesPage,
});

function DictTypesPage() {
  useDocumentTitle(t('字典管理'));
  const writable = canAccess(useAccess().data, 'dicts:write');
  const dictTypes = useDictTypes();
  const [createOpen, setCreateOpen] = useState(false);

  // 一个按钮，两个位置：有数据时在 ProTable 的工具栏里，没有数据时在空状态里 —— 同一时刻
  // 只会有其中一个在屏幕上。
  const createButton = writable ? (
    <Button
      key="create"
      type="primary"
      icon={<PlusOutlined />}
      onClick={() => setCreateOpen(true)}
    >
      {t('新建字典')}
    </Button>
  ) : undefined;

  return (
    <PageContainer header={{ title: t('字典管理') }}>
      <AsyncBoundary
        result={dictTypes}
        skeletonRows={6}
        emptyText={t('暂无数据')}
        emptyAction={createButton}
      >
        {(data) => (
          <DictTypeTable
            writable={writable}
            dictTypes={data}
            loading={dictTypes.isFetching}
            onReload={() => void dictTypes.refetch()}
            toolBar={createButton}
          />
        )}
      </AsyncBoundary>

      {writable && createOpen ? (
        <DictTypeFormModal onClose={() => setCreateOpen(false)} />
      ) : null}
    </PageContainer>
  );
}
